import { Injectable } from "@angular/core";
import { I18NextPipe } from "angular-i18next";
import { GroupingValue, Months } from "src/app/enums";

@Injectable({
    providedIn: 'root'
})
export class ChartUtilitiesService {
    constructor(private i18nextPipe: I18NextPipe) { }

    getMonthName(month: Months) {
        return {
            "01": "January",
            "02": "February",
            "03": "March",
            "04": "April",
            "05": "May",
            "06": "June",
            "07": "July",
            "08": "August",
            "09": "September",
            "10": "October",
            "11": "November",
            "12": "December"
        }[month];
    }

    getGroupingValue(value: GroupingValue, from: string, to: string, splitTag: string) {
        const { year: fromYear, month: fromMonth, day: fromDay, time: fromTime, dateString: fromDateString } = this.getDateTime(from);
        const { dateString: toDateString } = this.getDateTime(to);

        const groupingValueMap: Record<GroupingValue, string> = {
            "M": `${this.i18nextPipe.transform('dashboard:' + this.getMonthName(<Months>fromMonth))} ${fromYear}`,
            "D": `${fromDay}/${fromMonth}/${fromYear}`,
            "H": `${fromTime}${splitTag}${fromDateString}`,
            "Q": `${fromTime}${splitTag}${fromDateString}`,
            "W": `${fromDateString}${splitTag}${toDateString}`
        };

        return groupingValueMap[value]
    }

    getDateTime(stringToParse: string) {
        let [date, time, year, month, day] = "";
        if (stringToParse.indexOf("T") > - 1) {
            [date, time] = (stringToParse || "1970-01-01T00:00:00").split("T");
            [year, month, day] = date.split('-');
        } else {
            [date, time] = (stringToParse || "01/01/1970, 00:00:00").split(", ");
            [day, month, year] = date.split('/');
        }

        return { year, month, day, time, dateString: date, timeString: time };
    }
}